/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  Component,
  OnInit
}                                 from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';

import { Logger                }  from '@/util/logger';
import {ActivatedRoute, ParamMap} from "@angular/router";

@Component({
  standalone: false,
  templateUrl: 'panorama.component.html'
})

/**
 *
 * @class PanoramaComponent
 *
 * @brief the main viewer page for railview
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class PanoramaComponent implements OnInit {

  private panoIdOrUUID: string = '';

  /** standard constructor */
  constructor(
    private route: ActivatedRoute
  ) {

  }

  /** on page setup */
  ngOnInit() {

    const params: ParamMap = this.route.snapshot['queryParamMap'];

    /* normally the panorama ID should be our local PostgreSQL panorama row/object ID */

    this.panoIdOrUUID = params.get('id').trim();

    /*
     * if we get something that isn't a straight number, then it's likely that it's a
     * UUID from the panorama table, i.e. the "ID" from BigQuery and pano_db
     *
     */

    if (this.panoIdOrUUID) {

      if (!/^[0-9]+$/.test(this.panoIdOrUUID)) {

        Logger.debug(`[PanoramaComponent] init on UUID: ${this.panoIdOrUUID}...`);

        return ;
      }

    }

    Logger.debug(`[PanoramaComponent] init on ID: ${this.panoIdOrUUID}...`);


  }

}

